import ReportDataGrid from "./ReportDataGrid";

/** @deprecated Use ReportDataGrid */
const ReportResultsGrid = (props) => (
    <ReportDataGrid gridId={props.gridId || "report-grid"} {...props} />
);

export default ReportResultsGrid;
